import type { SortedProvidersIdsToOrder } from '@bcf-vanilla-ts-v1-configurators/tokens/slots/types';

export const cpSortedProviderNamesToOrder: SortedProvidersIdsToOrder = [
  'bf-games',
  'pragmatic-play',
  'greentube',
  'playn-go',
  'amusnet',
  'hacksaw',
  'evolution',
  'relax-gaming',
  'elk',
  'push-gaming',
  'fazi',
  'nolimit-city',
  'synot',
  'stakelogic',
  'wazdan',
  'netent',
  'gaming-corps',
  'red-tiger',
  'pragmatic-play-live',
  'swintt',
  'pg-soft',
  'thunderkick',
  'gamomat',
  'endorphina',
  'spinberry',
  'btg',
  'g.games',
  'spribe',
  'spinomenal',
  'on-air-entertainment',
  'raw',
  'red-rake-gaming',
  'wizard-games',
  'blueprint',
  'slotmill',
  'smartsoft',
  'games-global',
  'fantasma',
  'reelplay',
  'stakelogic-live',
  'leander-games',
  'tvbet',
  'ezugi'
];
